module.exports = __webpack_public_path__ + "9f7670eb970a5875be8cc4b06e253523.png";